import React from 'react';
import load from './partials/load.svg';
import { toast } from 'react-toastify';
class Inventario extends React.Component{
   entrada = React.createRef()
   constructor(props){
      super(props);
      this.state = {
         productos : [],
         inventario: [],
         load : false,
         search : '',
         opened : false,
         date : null
      }
      this.sesion = JSON.parse( localStorage.getItem('sesion'));
   }
   componentDidMount(){
      let fecha = new Date();
		let month = fecha.getMonth() + Number(1);
		month = month < 10 ? '0'+month : month;
		fecha = fecha.getDate()+'/'+month+'/'+fecha.getFullYear();
      this.setState({date:fecha});
		fetch(window.$api+'/productos/inventario/'+this.sesion.sucursal)
		.then(res=>res.json())
		.then(productos=>{
         this.setState({productos});
      });
      let local_storage = localStorage.getItem('invShantal');
      if( local_storage === null ){
         localStorage.setItem('invShantal','[]');
      }else{
         local_storage = JSON.parse(local_storage);
         this.setState({inventario: local_storage});
      }
      let self = this;
		let scannedBarcode="";
		document.onkeydown = e => {
			if (e.key !== "Enter" ) {
				scannedBarcode += e.key;
			}
			if (e.key === "Enter" ) {
				scannedBarcode = scannedBarcode.replace("'","-");
				scannedBarcode = scannedBarcode.trim();
				self.addInventary(scannedBarcode);
				scannedBarcode = '';
			}
		};
   }
   componentWillUnmount() {
		window.onkeydown = null;
      this.setState = () => false;
	}
   addInventary = codigo => {
      let inventario = JSON.parse( localStorage.getItem('invShantal') );
      let producto_inventario = inventario.find(p=>p.codigo===codigo);
      if( producto_inventario === undefined ){
         let find_product = this.state.productos.find(p=>p.codigo===codigo);
         if( find_product !== undefined ){
            find_product.cantidad = 1;
            inventario.push(find_product);
         }
      }else{
         inventario.map(p=>{
            if( p.codigo===codigo){
               p.cantidad = Number(p.cantidad) + 1;
            }
            return p;
         });
      }
      localStorage.setItem('invShantal',JSON.stringify(inventario));
      // Trabajamos con la copia y actualizamos el estado
      this.setState({inventario});
   }
   searchProduct = () => {
      let search = this.state.search;
      if( search === '' ){
         toast.warning("Ingrese el código de producto...");
      }else{
         if( this.entrada.current.value === '' ){
            toast.warning("Ingrese la cantidad de producto...");
         }
      }
      if( search !== '' && this.entrada.current.value !== '' ){
         let producto = this.state.productos.find(p=>p.codigo===search);
         if( producto ){
            producto.cantidad = parseInt(this.entrada.current.value);
            this.pushList(producto);
         }else{
            toast.warning("El producto no existe...");
         }
      }
   }
   // Actualizamos el estado del input y detectamos el evento enter
	searchHandler = e =>{
      let search = e.target.value;
      e.keyCode === 13 ? this.searchProduct() : this.setState({search});
   }
   pushList = (producto) => {
      let _productos = [];
      let isExist = true;
      // Si hay objetos en el inventario continuamos....
      if( this.state.inventario.length > 0 ){
         _productos = JSON.parse( localStorage.getItem('invShantal') );
         _productos.map(p=>{
            if( p.id===producto.id ){
               isExist = false;
               p.cantidad = Number(p.cantidad) + Number(this.entrada.current.value);
            }
            return p;
         });
         // El inventario tiene objetos sin embargo el que traemos como argumento
         // no existe en el
         if( isExist ){
            _productos.push(producto);
         }
      }else{
         // Cuando el inventario esta vacio...
         _productos.push(producto);
      }
      localStorage.setItem('invShantal',JSON.stringify(_productos));
      // Trabajamos con la copia y actualizamos el estado
      this.setState({inventario: _productos });
   }
   closeSuccess = () =>{
      const success = ! this.state.success;
      this.setState({success});
   }
   discard = () => {
      const message = "";
      const openConfirm = ! this.state.openConfirm;
      this.setState({openConfirm,message});
   }
   confirm = () => {
      const opened = ! this.state.opened;
      this.setState({opened});
   }
   saveInventory = () => {
      let productos = JSON.parse( localStorage.getItem('invShantal') );
      if( productos.length > 0 ){
         let load = !this.state.load;
         const opened = !this.state.opened;
         this.setState({load, opened});
         let body = {
            session : this.sesion,
            content : productos,
            fecha : window.$created_at()
         }
         let config = {
            method : 'POST',
            body : JSON.stringify(body),
            headers : {'Content-Type': 'application/json'}
         };
         fetch(window.$api+'/inventario',config)
         .then(res=>res.json())
         .then(
            response=>{
               load = !this.state.load;
               const productos = [], inventario = [];;
               this.setState({load, productos, inventario});
               if( response.status === 200 ){
                  toast.success(response.message);
                  localStorage.setItem('invShantal','[]');
               }else{
                  toast.warning(response.message);
               }
            },
            error=>{
               load = !this.state.load;
               this.setState({load});
            }
         );
      }else{
         toast.warning("El inventario esta vacio...");
      }
   }
   changeCant = (indice, signo ) => {
      let inventario = JSON.parse( localStorage.getItem('invShantal') );
      if( signo === '+'){
         inventario[indice].cantidad++;
      }else{
         if( inventario[indice].cantidad > 1 ){
            inventario[indice].cantidad--;
         }
      }
      localStorage.setItem('invShantal',JSON.stringify(inventario));
      this.setState({inventario});
   }
   removeItem = (id) => {
      let inventario = JSON.parse( localStorage.getItem('invShantal') );
      let _inventario = inventario.filter(e=>e.id!==id);
      localStorage.setItem('invShantal',JSON.stringify(_inventario));
      inventario = _inventario;
      this.setState({inventario});
   }
   render(){
      let list = [];
      if( this.state.inventario.length > 0 ){
			this.state.inventario.forEach((producto, index)=>{
            list.push(
               <tr key={index}>
               <td className="codigo">{producto.codigo}</td>
               <td className="producto">{producto.nombre}</td>
               <td className="existencia">
                  {producto.cantidad}
                  <span className='count'>
                     <span key={0} onClick={()=>this.changeCant(index,'+')} className='arrow-up'></span>
                     <span key={1} onClick={()=>this.changeCant(index,'-')} className='arrow-down'></span>
                  </span>
               </td>
               <td><span className='icon-trash' onClick={()=>this.removeItem(producto.id)}></span></td>
            </tr>
				);
			});
		}
      return (
         <div className="wrap-module">
            <h1>Inventario</h1>
            <div className="wrap-content" style={{top:'20px'}}>
               <div className="xs-12 sm-4 md-4 lg-4">
                  <label>Ingrese / Escanee <br/>el código del producto</label>
                  <p><input 
                     type="text" 
                     className="input-normal" 
                     placeholder="Buscar…"
                     onKeyUp={this.searchHandler}
                  />
                  </p>
               </div>
               <div className="xs-12 sm-2 md-2 lg-2">
                  <br/><label>Cantidad</label>
                  <p><input 
                     type="number" 
                     min="1"
                     max="1000"
                     ref={this.entrada}
                     className="input-normal" 
                     placeholder="Cantidad…"
                     style={{paddingRight:'1px'}}/>
                  </p>
               </div>
               <div className="xs-12 sm-2 md-2 lg-2" style={{top:'3px', position : 'relative'}}><label>&nbsp;</label>
                  <br/><div onClick={this.searchProduct} className="btn-medium btn-green max-width">Agregar</div>
               </div>
               <div className="xs-12 sm-4 md-4 lg-3" style={{top:'3px', position : 'relative'}}><label>&nbsp;</label>
                  <br/><div onClick={this.confirm} className="btn-medium btn-green max-width">Guardar Inventario</div>
               </div>
               <div className="xs-12 sm-12 md-12 lg-12">
                  <hr/>
                     <p>
                        <span>Fecha: {this.state.date}</span> | 
                        <span> Sesión: {this.sesion.name}</span>
                     </p>
                  <hr/>
               </div>
               <div className="xs-12 sm-12 md-12 lg-12">
               {this.state.inventario.length>0&&
                  <table style={{top:'0px'}}>
                     <thead>
                        <tr>
                           <th className="th">Código</th><th className="th">Nombre</th>
                           <th className="th">Cantidad</th><th className="th">#</th>
                        </tr>
                     </thead>
                     <tbody>{list}</tbody>
                  </table>
               }
               </div>
            </div>
            <div className={this.state.load?'load show':'load'}>
               <img src={load} alt='load'/>
            </div>
            <div className={this.state.opened?'overlay confirm show':'overlay confirm'}>
               <div className="alert text-center">
                  <h3>¿Desea finalizar la captura?</h3>
                  <div className="btn btn-green" onClick={this.saveInventory}>Aceptar</div>
                  <div className="btn btn-red" onClick={this.confirm}>Descartar</div>
               </div>
            </div>
         </div>
   );
   }
}
export default Inventario;